import React, { type FC } from "react";
import "./JetpackLoader.sass";

interface Props {
  loading: boolean;
  isFullScreen: boolean;
  text?: string;
}

/**
 * A full-screen loader.
 * @param props
 * @constructor
 */
const JetpackLoader: FC<Props> = (props: Props) => {
  return (
    <div
      id="jetpack-loader"
      style={{
        display: props.loading ? "flex" : "none"
      }}
    >
      <div
        className={["loader-bg", props.isFullScreen ? "full-screen" : ""].join(
          " "
        )}
      />
      <div className="loader-container">
        <span className="jp-loader"></span>
        <p className={"loader-text"}>{props?.text}</p>
      </div>
    </div>
  );
};

export default JetpackLoader;
